module.exports = __webpack_public_path__ + "assets/chevron-down-0a65a3.svg";